import React from "react";

const FullScreenLoader = () => {
    return (
        <div className="fullscreen-loader">
            <img className="fullscreen-loader" src="/loading_coke.gif"/>
            {/*<div className="bar-loader" />*/}
        </div>
    );
};

export default FullScreenLoader;
